const experience = [
    {
        title: "Graduate Researcher",
        company: "University of Michigan-Dearborn",
        location: "Dearborn, MI",
        duration: "Sep 2026 – Present",
        contributions: [
            "Building a Docker-isolated evaluation pipeline for LLM-generated software repairs on SWE-bench Verified, combining integrity checks, regression tests, static analysis, and issue-derived reproduction tests with 840+ automated tests.",
            "A pre-registered audit halted an early study run after detecting environment leakage in 8 of 50 audited tasks; added container masking and integrity checks before restarting the experiment.",
        ],
        technologies: ["Python", "SWE-bench", "Docker", "Pytest", "Static Analysis", "LLM Evaluation"],
        image: "/assets/experience/umdearborn.png",
    },
    {
        title: "Data Science Intern",
        company: "Magna International",
        team: "Advanced Manufacturing Innovation R&D",
        location: "Troy, MI",
        duration: "05/2026 – 08/2026",
        contributions: [
            "Validated a multi-camera stamped-part inspection PoC with up to $7M/year in projected labor savings, proving feature registration and cross-camera deduplication on 2- and 4-camera rigs using SIFT/RANSAC calibration and geometric/Hungarian matching.",
            "Delivered a lens-debris inspection pipeline projected to save ~$700K/year in labor, achieving 100% recall and 96% precision with high-pass filtering, CLAHE preprocessing, and PatchCore; handed the validated system off to the manufacturing plant.",
            "Productionized an unsupervised visual-inspection pipeline for a Magna Seating plant in Spain, achieving 100% defect recall, 95.2% precision, and ~300 ms end-to-end latency on NVIDIA Jetson AGX Orin using YOLOX, NanoSAM, PatchCore, ONNX, TensorRT FP16, Docker, and NVIDIA Triton.",
        ],
        technologies: [
            "Python",
            "PyTorch",
            "PatchCore",
            "YOLOX",
            "NanoSAM",
            "OpenCV",
            "ONNX",
            "TensorRT",
            "NVIDIA Triton",
            "Jetson AGX Orin",
            "Docker",
        ],
        image: "/assets/experience/magna.png",
    },
    {
        title: "AI Engineering Intern",
        company: "Zoetis",
        location: "Kalamazoo, MI",
        duration: "05/2025 – 11/2025",
        contributions: [
            "Deployed 4 production LLM tools on Azure Kubernetes using asynchronous ETL and semantic matching, reducing regulated documentation effort by 1,000+ engineer-hours annually.",
            "Reduced incident misclassification by ~40% by building a real-time SQL-backed analytics workflow with Plotly dashboards and automated openpyxl Excel exports.",
        ],
        technologies: ["Python", "Streamlit", "MySQL", "LLM APIs", "Plotly", "AKS", "Posit Connect"],
        image: "/assets/experience/zoetis.png",
    },
    {
        title: "AI/ML Engineer Intern",
        company: "Mistral Solutions Pvt Ltd",
        location: "Bangalore, KA",
        duration: "06/2024 – 08/2024",
        contributions: [
            "Reduced UAV inference latency by 25% by quantizing YOLOv8 and ByteTrack with the Qualcomm SNPE SDK on a QRB5165 edge platform; built and deployed a VGG16-based vehicle classification model through the same SNPE pipeline.",
            "Enabled real-time range and thermal telemetry by integrating Lightware LW20/C LiDAR and DS1820 sensors through Arduino and I2C-based hardware-software interfaces.",
        ],
        technologies: ["Python", "TensorFlow", "YOLOv8", "Arduino", "Lua", "Qualcomm SNPE SDK"],
        image: "/assets/experience/mistral1.png",
        report: "/reports/Internship Report.pdf",
    },
    {
        title: "Software Developer",
        company: "Astroseed",
        location: "Tempe, AZ",
        duration: "08/2023 – 05/2024",
        contributions: [
            "Built ROS-based autonomous plant-care software for the Terra Pod, integrating depth-camera perception, YOLO/Canny-based vision, and robotic control for pruning and harvesting tasks.",
            "Improved autonomous navigation and manipulation by combining 2D SLAM with depth-based distance and size estimation for robotic-arm interactions.",
        ],
        technologies: ["YOLOv5", "SLAM", "Python", "ROS", "Gazebo"],
        image: "/assets/experience/astroseed.png",
        report: "/reports/Final Report_astroseed.pdf",
    },
    {
        title: "Teaching Assistant",
        company: "Arizona State University",
        location: "Tempe, AZ",
        duration: "08/2022 – 05/2024",
        contributions: [
            "Mentored 100+ first-year students through individualized academic guidance and course support.",
        ],
        technologies: ["Mentoring", "Academic Guidance"],
        image: "/assets/experience/asu.png",
    },
    {
        title: "Software Development Engineering Intern",
        company: "Machani Robotics",
        location: "Bangalore, KA",
        duration: "06/2022 – 08/2022",
        contributions: [
            "Built ROS/MoveIt control software for a 6-DOF robotic arm, integrating Intel RealSense D435i perception and inverse-kinematics-based pick-and-place workflows.",
            "Implemented image-to-coordinate trajectory generation with OpenCV and Canny edge detection, while synchronizing RMD motors over CAN for robotic drawing and motion-control tasks.",
        ],
        technologies: ["Python", "ROS", "C++", "CAN Communication", "3D Depth Cameras"],
        image: "/assets/experience/machani-robotics.png",
        report: "/reports/PROJECT REPORT_machanirobotics.pdf",
    },
];

export default experience;
